export default {
  items: [
    {
      name: 'ホーム',
      url: '/Home',
      icon: 'icon-home'
    },
    {
      name: '物件管理',
      url: '/Plan',
      icon: 'icon-folder-alt'
    },
    {
      name: '利用状況',
      url: '/State',
      icon: 'icon-speech'
    },
    {
      name: 'プラン変更',
      url: '/Grade',
      icon: 'icon-credit-card'
    },
    // {
    //   name: 'プロフィール',
    //   url: '/Profile',
    //   icon: 'icon-user'
    // },
    // {
    //   name: '設定',
    //   url: '/Setting',
    //   icon: 'icon-settings'
    // },
    {
      name: 'ログアウト',
      icon: 'icon-logout',
      button: 'logout'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/_nav.js